import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qh7ymfdb7c: FaireBrandEntity = {
  token: "b_qh7ymfdb7c",
  type: "brand",
  name: "Boon",
  avatarUrl:
    "https://cdn.faire.com/fastly/2e19f83899f0b835583af290619f85f7de59ea15a80eed6f685edc4bce5737f4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/dbb8886247fa13bd2fb07d08f5d54767d851585219ed585a76a54219c54c4335.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2e19f83899f0b835583af290619f85f7de59ea15a80eed6f685edc4bce5737f4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dbb8886247fa13bd2fb07d08f5d54767d851585219ed585a76a54219c54c4335.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Boon is a Los Angeles-based small batch chili oil created by Max Boonthanakit. Inspired by his love for the traditional Chinese chili crisp, Boon is a reflection of Boonthanakit’s Thai/Chinese upbringing and culinary experience.\n\nAfter polishing off various brands of supermarket chili oil, Boonthanakit realized there was always something missing - more flavor. Fueled by his spice addiction, he went on to craft his version of the perfect chili oil which included a lot more flavor, heat, and the perfect balance of spices for a more universal taste! \n\nWhat started off as a hobby and a way to make ends meet, Boon has built a cult following amongst friends and family with each person rationing their supply as they wait for the next batch.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:46.797Z",
    importedBy: "entity-db-cli",
  },
};
